import React from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

const Divider = ({ sx }: { sx?: SxProps }) => (
  <Box
    as="hr"
    sx={{
      display: 'inline-block',
      height: '1px',
      width: '100%',
      border: 'none',
      bg: 't.black20',
      margin: '16px 0',
      ...sx,
    }}
  />
);

export default Divider;
